if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        // Personalization Changes
        this.buyNowButton = this.querySelector("#gokwik-buy-now");
        this.buyNowOnclickFunction = this.buyNowButton.getAttribute("onclick");
        this.isBuyNow = false;
        this.productType = this.getAttribute("data-product-type");
        this.isBOBJ = this.getAttribute("data-bobj-product");
        this.customizationDone = false;
        this.personalizationValue = null;
        this.personalizationModal = document.querySelector(
          ".personalization-message-modal"
        );
        this.personalizationOverlay = document.querySelector(
          ".personalization-message-modal-overlay"
        );
        this.personalizationInput =
          document.getElementById("personalized-text");
        this.personalizationPreview = document.querySelector(
          ".customize-text-image"
        );
        this.warningMessage = document.querySelector(
          ".personalization-warning-message"
        );
        this.personalizationAddButton = document.getElementById(
          "personalization_to_cart"
        );
        this.personalizationSkipButton = document.getElementById(
          "skip_personalization_button"
        );
        this.closeIcon = document.getElementById("close-icon");
        this.variantModal = document.querySelector(".available-variants-modal");
        this.variantModalClose = document.getElementById("availableModalClose");
        this.personalizationWrapper = document.querySelector(
          ".personalization-product__button"
        );
        if (this.productType === "Jeans" && this.personalizationWrapper) {
          this.personalizationWrapper.addEventListener("click", (e) => {
            e.preventDefault();
            this.checkSizeThenOpen();
          });
        }
        this.closeIcon?.addEventListener("click", (e) => {
          e.preventDefault();
          this.closePersonalizationModal();
          this.resetPersonalizationState();
        });

        this.personalizationOverlay?.addEventListener("click", (e) => {
          e.preventDefault();
          this.closePersonalizationModal();
          this.resetPersonalizationState();
        });
        this.boundHandlePersonalizationSubmit =
          this.handlePersonalizationSubmit.bind(this);
        this.boundHandlePersonalizationSkip =
          this.handlePersonalizationSkip.bind(this);

        if (this.personalizationInput) {
          const allowedCharsRegex = /[^a-zA-Z0-9()_!@# -]/g;
          const maxLength = 12;

          const filterContent = [
            // Profanity
            "FUCK",
            "ASS",
            "FUCK YOU",
            "MOTHERFUCKER",
            "ASSHOLE",
            "BASTARD",
            "IDIOT",
            "RETARD",
            "DICKHEAD",
            "DOUCHE BAG",
            "MORON",
            "CRAP",
            "STUPID",
            "SUCKER",
            "SHIT",
            "PISS",
            "CUNT",
            "BITCH",
            "SLUT",
            "DUMBASS",
            "WHORE",

            // Slang and abbreviated profanities
            "WTF",
            "LMFAO",
            "OMFG",
            "POS",
            "DAMN",
            "XXX",
            "SEX",
            "WWWW",
            "@@@@",
            "####",
            "!!!!",
            "----",
            "____",

            // Brands
            "WRANGLER",
            "LEE",
            "PEPE JEANS",
            "SPYKAR",
            "DIESEL",
            "USPA",
            "JACK&JONES",
            "FLYING MACHINE",
            "KILLER",
            "MUFTI",
            "DENIZEN",
            "CALVIN KLEIN",
            "TOMMY JEANS",
            "TRUE RELIGION",
            "GUESS",
            "LEE COOPER",
            "H&M",
            "PUMA",
            "ZARA",
            "NIKE",
            "ADIDAS",

            // Religion / Politics
            "MODI",
            "BJP",
            "CONGRESS",
            "JESUS",
            "ALLAH",
            "RAM",
            "TEMPLE",
            "CHURCH",
            "MANDIR",
            "QURAN",
            "BIBLE",
            "NAMO",
            "OM",

            // Other offensive or sensitive
            "HITLER",
            "NAZI",
            "ISIS",
            "TERROR",
            "BOMB",
            "RAPE",
            "GUN",
            "MURDER",
          ];

          function normalize(str) {
            return str.replace(/[\s&-]/g, "").toUpperCase();
          }

          this.personalizationInput.addEventListener("input", (e) => {
            let input = e.target.value;
            let showWarning = false;
            let warningText = "";

            // Check for non-allowed characters
            if (allowedCharsRegex.test(input)) {
              input = input.replace(allowedCharsRegex, "");
              warningText =
                "Only letters, numbers, and these characters allowed: ()_!@# -";
              showWarning = true;
            }

            input = input.toUpperCase();

            // Check for length overflow
            if (input.length > maxLength) {
              input = input.slice(0, maxLength);
              if (!showWarning) {
                warningText = `Maximum ${maxLength} characters allowed.`;
                showWarning = true;
              }
            }

            const normalizedInput = normalize(input.trim());
            const isBlocked = filterContent.some((blocked) =>
              normalizedInput.includes(blocked)
            );

            if (isBlocked) {
              input = input.slice(0, -1); // Remove last character
              warningText = "Entered word or phrase is not allowed.";
              showWarning = true;
            }

            e.target.value = input;
            this.personalizationPreview.textContent = input.trim();

            // Toggle Add button
            if (input.trim()) {
              this.personalizationAddButton.classList.remove("tw-hidden");
            } else {
              this.personalizationAddButton.classList.add("tw-hidden");
            }

            // Show warning if needed
            if (showWarning && this.warningMessage) {
              this.warningMessage.textContent = warningText;
              this.warningMessage.classList.remove("tw-hidden");
              setTimeout(() => {
                this.warningMessage.classList.add("tw-hidden");
              }, 5000);
            }
          });

          let originalHeight = window.innerHeight;

          this.personalizationInput.addEventListener("focus", () => {
            if (window.innerWidth <= 750) {
              setTimeout(() => {
                const newHeight = window.innerHeight;
                const keyboardHeight = originalHeight - newHeight;

                if (keyboardHeight > 100) {
                  document.body.style.paddingBottom = `${keyboardHeight}px`;
                }
                this.personalizationInput.scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                });
              }, 300);
            }
          });
        }
      }

      openPersonalizationModal() {
        this.personalizationModal.classList.remove("hide");
        this.personalizationModal.classList.add("show");
        this.personalizationOverlay.classList.remove("hide");
        this.personalizationOverlay.classList.add("show");
        document.body.style.overflow = "hidden";
        if (window.innerWidth >= 750) {
          stickyHeaderDiv.style.position = "static";
          stickyAnnouncementBar.style.position = "static";
        }

        this.personalizationAddButton.removeEventListener(
          "click",
          this.boundHandlePersonalizationSubmit
        );
        this.personalizationSkipButton.removeEventListener(
          "click",
          this.boundHandlePersonalizationSkip
        );

        this.personalizationAddButton.addEventListener(
          "click",
          this.boundHandlePersonalizationSubmit,
          { once: true }
        );
        this.personalizationSkipButton.addEventListener(
          "click",
          this.boundHandlePersonalizationSkip,
          { once: true }
        );
      }

      closePersonalizationModal() {
        this.personalizationModal.classList.add("hide");
        this.personalizationModal.classList.remove("show");
        this.personalizationOverlay.classList.add("hide");
        this.personalizationOverlay.classList.remove("show");
        document.body.style.overflow = "auto";
        if (window.innerWidth >= 750) {
          stickyHeaderDiv.removeAttribute("style");
          stickyAnnouncementBar.removeAttribute("style");
        }
      }

      handlePersonalizationSubmit() {
        const value = this.personalizationInput.value.trim();
        if (value.length > 0) {
          this.personalizationValue = value;
          this.customizationDone = true;
        }
        this.closePersonalizationModal();
        this.submitForm();
      }

      handlePersonalizationSkip() {
        this.personalizationValue = null;
        this.customizationDone = true;
        this.closePersonalizationModal();
        this.submitForm();
      }

      resetPersonalizationState() {
        this.personalizationValue = null;
        this.customizationDone = false;
        const input = document.getElementById("personalized-text");
        const preview = document.querySelector(".customize-text-image");
        if (input) input.value = "";
        if (preview) preview.textContent = "";
      }

      checkSizeThenOpen() {
        const variantRadios = document.querySelector(
          "variant-radios-unselected"
        );
        if (!variantRadios) {
          this.openPersonalizationModal();
          return;
        }
        variantRadios.updateOptions();
        const options = variantRadios.options;

        const isAllSelected = !options.includes(undefined);
        if (isAllSelected) {
          this.openPersonalizationModal();
        } else {
          this.openSizeModal();
        }
      }

      openSizeModal() {
        if (!this.variantModal) return;

        this.variantModal.style.display = "block";
        this.variantModal.classList.add("showing-modal");
        document.body.style.overflow = "hidden";
        if (window.innerWidth >= 750) {
          stickyHeaderDiv.style.position = "static";
          stickyAnnouncementBar.style.position = "static";
        }
        let addButtonSizeOption = document.getElementById(
          "add_button_size_popup"
        );
        const sizeOptions = document.querySelectorAll(".size_variant");
        sizeOptions.forEach((sizeOption) => {
          sizeOption.addEventListener(
            "click",
            () => {
              sizeOption.click();
            },
            { once: true }
          );
        });
        addButtonSizeOption.addEventListener("click", () => {
          this.closeSizeModal();
          this.openPersonalizationModal();
        });
        this.variantModalClose?.addEventListener(
          "click",
          () => {
            this.closeSizeModal();
          },
          { once: true }
        );
        this.variantModal?.addEventListener("click", (event) => {
          if (event.target === this.variantModal) {
            this.closeSizeModal();
          }
        });
      }

      closeSizeModal() {
        if (this.variantModal) {
          this.variantModal.style.display = "none";
          this.variantModal.classList.remove("showing-modal");
          document.body.style.overflow = "auto";
          if (window.innerWidth >= 750) {
            stickyHeaderDiv.removeAttribute("style");
            stickyAnnouncementBar.removeAttribute("style");
          }
        }
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        const clickedButton = evt.submitter;
        this.isBuyNow = clickedButton?.id === "gokwik-buy-now";

        this.handleErrorMessage();

        if (this.productType === "Jeans" && !this.customizationDone) {
          this.openPersonalizationModal();
          return;
        }

        this.checkSizeThenOpen();
      }

      async submitForm() {
        const cart = await fetch("/cart.js").then((res) => res.json());
        const cartItems = cart.items;
        const incomingCustomization = this.personalizationValue?.trim() || "";

        let cartHasCustomItem = false;
        let cartCustomItemCount = 0;

        for (const item of cartItems) {
          if (item.properties && item.properties.CustomizationText) {
            cartHasCustomItem = true;
            cartCustomItemCount += item.quantity;
          }
        }

        if (cartHasCustomItem && incomingCustomization === "") {
          this.showPopupError(
            "You cannot add a non-customized product to cart with customized product."
          );
          return;
        } else if (
          cartHasCustomItem &&
          incomingCustomization !== "" &&
          cartCustomItemCount >= 1
        ) {
          this.showPopupError("No Customized product is allowed in the cart.");
          return;
        } else if (
          !cartHasCustomItem &&
          cartItems.length > 0 &&
          incomingCustomization !== ""
        ) {
          this.showPopupError(
            "You cannot add customized product to cart with non-customize product."
          );
          return;
        }

        this.closeSizeModal();

        if (this.isBuyNow) {
          this.buyNowButton?.setAttribute(
            "onclick",
            this.buyNowOnclickFunction
          );
        }

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        showLoader();

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        const formData = new FormData(this.form);
        if (incomingCustomization !== "") {
          formData.append(
            "properties[CustomizationText]",
            incomingCustomization
          );
          formData.append("quantity", 1);
        }

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        try {
          const response = await fetch(`${routes.cart_add_url}`, config);
          const data = await response.json();

          if (data.status) {
            this.handleErrorMessage(data.description);
            const soldOutMessage =
              this.submitButton.querySelector(".sold-out-message");
            if (!soldOutMessage) return;
            this.submitButton.setAttribute("aria-disabled", true);
            this.submitButton.querySelector("span").classList.add("hidden");
            soldOutMessage.classList.remove("hidden");
            this.error = true;
            return;
          }

          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, { source: "product-form" });
            this.error = false;

            window.dispatchEvent(
              new CustomEvent("cart:item_added", {
                bubbles: true,
                detail: {
                  data
                }
              })
            );

          const quickAddModal = this.closest("quick-add-modal");
          if (quickAddModal) {
            document.body.addEventListener(
              "modalClosed",
              () => {
                setTimeout(() => {
                  this.cart.renderContents(data);
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(data);
          }
        } catch (e) {
          console.error(e);
        } finally {
          this.submitButton.classList.remove("loading");
          if (this.cart && this.cart.classList.contains("is-empty"))
            this.cart.classList.remove("is-empty");
          if (!this.error) this.submitButton.removeAttribute("aria-disabled");
          closeLoader();
          window.initMoveAllToWishlist();
          this.customizationDone = false;
          this.personalizationValue = null;
        }
      }

      showPopupError(message, duration = 5000) {
        this.closeSizeModal();
        let existingPopup = document.querySelector(".custom-error-popup");
        if (existingPopup) {
          existingPopup.remove();
        }

        const popup = document.createElement("div");
        popup.className =
          "custom-error-popup tw-text-center bmd:tw-w-[90%] md:tw-w-[60%] tw-p-4 md:tw-p-8 tw-text-[12px] md:tw-text-[16px]";
        popup.textContent = message;

        Object.assign(popup.style, {
          position: "fixed",
          bottom: "20px",
          left: "50%",
          transform: "translateX(-50%)",
          background: "#c41320",
          color: "#fff",
          padding: "12px 20px",
          borderRadius: "6px",
          zIndex: 10000,
          boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
          transition: "opacity 0.3s ease-in-out",
        });

        document.body.appendChild(popup);

        setTimeout(() => {
          popup.style.opacity = "0";
          setTimeout(() => popup.remove(), 300);
        }, duration);
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

// Get the size guide button and the elements to show/hide the SIZE GUIDE
const sizeGuideButton = document.getElementById("sizeGuideButton");
const sizeGuideBackground = document.querySelector(".size-guide-background");
const stickyHeaderDiv = document.querySelector(".to-handle-zIndex-sizeGuide");
const stickyAnnouncementBar = document.querySelector(
  ".announcement-bar-section"
);
const sizeGuideImageContainer = document.querySelector(".size-guide-image");

// Function to show the size guide
function showSizeGuide() {
  sizeGuideBackground.classList.add("!tw-block");
  sizeGuideImageContainer.classList.remove("tw-hidden");
  sizeGuideImageContainer.classList.add("tw-flex");
  document.body.style.overflow = "hidden";
  // Only set zIndex on desktop devices
  if (window.innerWidth >= 998) {
    stickyHeaderDiv.style.position = "static";
    stickyAnnouncementBar.style.position = "static";
  }
}

// Function to hide the size guide
function hideSizeGuide() {
  sizeGuideBackground.classList.remove("!tw-block");
  sizeGuideImageContainer.classList.add("tw-hidden");
  sizeGuideImageContainer.classList.remove("tw-flex");
  document.body.style.overflow = "auto";
  if (window.innerWidth >= 998) {
    stickyHeaderDiv.removeAttribute("style");
    stickyAnnouncementBar.removeAttribute("style");
  }
}

// PRODUCT UNAVAILABLE VARIANT SHOW ON PDP

let sizeModal = document.querySelector(".product-size-modal");
let sizeClose = document.getElementById("size-close");
if (sizeModal) {
  document
    .querySelectorAll("fieldset .size-unavailable-variant")
    .forEach((e) => {
      e.addEventListener("click", function () {
        // Create the object with properties
        const productDetails = {
          clickedValue: e.getAttribute("data-clicked-value"),
          pdPrice: e.getAttribute("data-pd-price"),
          pdFitNumber: e.getAttribute("data-fit-number"),
          pdFitStyle: e.getAttribute("data-fit-style"),
          pdType: e.getAttribute("data-pd-type"),
          pdGender: e.getAttribute("data-pd-gender"),
        };

        // Call the function and pass the object
        fetchProductGrid(productDetails);

        sizeModal.style.display = "block";
        document.body.style.overflow = "hidden";
        if (window.innerWidth >= 750) {
          stickyHeaderDiv.style.position = "static";
          stickyAnnouncementBar.style.position = "static";
        }
      });
    });

  if (sizeClose) {
    sizeClose.onclick = function () {
      sizeModal.style.display = "none";
      document.body.style.overflow = "auto";
      if (window.innerWidth >= 750) {
        stickyHeaderDiv.removeAttribute("style");
        stickyAnnouncementBar.removeAttribute("style");
      }
    };
  }

  // When the user clicks anywhere outside of the modal, close it
  sizeModal.onclick = function (event) {
    if (event.target == sizeModal) {
      sizeModal.style.display = "none";
      document.body.style.overflow = "auto";
      if (window.innerWidth >= 750) {
        stickyHeaderDiv.removeAttribute("style");
        stickyAnnouncementBar.removeAttribute("style");
      }
    }
  };

  async function fetchProductGrid(productDetails) {
    const { clickedValue, pdPrice, pdFitNumber, pdFitStyle, pdType, pdGender } =
      productDetails;
    showLoader();

    // Convert pdPrice to a number
    const convertPrice = parseFloat(pdPrice.replace(/[₹,]/g, ""));
    const lowerPrice = Math.floor(convertPrice * 0.9);
    const upperPrice = Math.floor(convertPrice * 1.1);
    const converFit = pdFitStyle.replaceAll(" ", "+");

    let fetchURL;
    if (pdFitNumber) {
      fetchURL = `https://levi.in/collections/${pdGender}?view=related-collection`;
    } else {
      fetchURL = `https://levi.in/collections/${pdGender}?view=related-collection`;
    }

    try {
      const response = await fetch(fetchURL);

      // Check if the response is successful
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const responseText = await response.text();
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(responseText, "text/html");
      const productGrid = htmlDocument.querySelector("#product-grid");
      const productAvailableSize = document.querySelector(
        ".product-available-size"
      );
      const productsFound = document.querySelector(".products-found");
      const sizesUnavailable = document.querySelector(".sizes-unavailable");

      // Toggle visibility of elements based on availability
      if (productsFound.classList.contains("tw-hidden")) {
        productsFound.classList.remove("tw-hidden");
        if (!sizesUnavailable.classList.contains("tw-hidden")) {
          sizesUnavailable.classList.add("tw-hidden");
        }
      }
      if (productGrid) {
        // Update the displayed size
        productAvailableSize.innerHTML = productDetails.clickedValue;
        const productCards = productGrid.querySelectorAll(".product-card");
        // Get filtering values
        const sizeToMatch = clickedValue;
        const typeToMatch = pdType;
        const fitToMatch = pdFitStyle.toLowerCase(); // optional if using fit
        const fitNumberToMatch = pdFitNumber;
        const lowerPrice = Math.floor(convertPrice * 0.8);
        const upperPrice = Math.floor(convertPrice * 1.2);

        // Filter product cards
        const filteredCards = Array.from(productCards).filter((card) => {
          const variantsData = card.getAttribute("data-variants");
          if (!variantsData) return false;

          let variants;
          try {
            variants = JSON.parse(variantsData);
          } catch (e) {
            console.error("Invalid JSON in data-variants:", e);
            return false;
          }

          // Match if any variant has size OR price in range AND correct product_type
          return variants.some((variant) => {
            const sizeMatch = variant.size === clickedValue;
            const priceMatch =
              variant.price >= lowerPrice && variant.price <= upperPrice;
            const typeMatch = variant.product_type === pdType;
            return (sizeMatch || priceMatch) && typeMatch;
          });
        });

        // Clear and update product container
        productsFound.innerHTML = "";

        if (filteredCards.length > 0) {
          filteredCards.slice(0, 10).forEach((card) => {
            const li = document.createElement("li");
            li.classList.add("product-size-list", "tw-border");
            li.appendChild(card.cloneNode(true));
            productsFound.appendChild(li);
          });

          productsFound.classList.remove("tw-hidden");
          sizesUnavailable.classList.add("tw-hidden");
        } else {
          productsFound.classList.add("tw-hidden");
          sizesUnavailable.classList.remove("tw-hidden");
          sizesUnavailable.classList.add("tw-flex");
        }
      } else {
        // Handle case when product grid is not found
        productsFound.classList.add("tw-hidden");
        sizesUnavailable.classList.remove("tw-hidden");
        sizesUnavailable.classList.add("tw-flex");
      }
    } catch (error) {
      console.error("Error fetching the product grid:", error);
    } finally {
      closeLoader();
    }
  }
}

const sizeVariant = document.querySelectorAll(".size_variant");
const sizePopUp = document.querySelectorAll(".size-pop-variant");
const addButton = document.querySelector(".product-form__submit");
const variantModalClose = document.querySelector("#availableModalClose");

const removeSelectedClass = (optionName) => {
  sizePopUp.forEach((pop) => {
    let popOptionName = pop.getAttribute("data-pop-size");
    if (popOptionName.includes(optionName)) {
      pop.classList.remove("size-selected");
    }
  });
};

const sizePopClick = (element) => {
  let dataSelectedSize = element.getAttribute("data-pop-size");
  let optionName = dataSelectedSize.includes("Size") ? "Size" : "Length";

  removeSelectedClass(optionName);
  sizeVariant.forEach((variant) => {
    let dataMatchedSize = variant.getAttribute("data-pop-size");
    if (dataSelectedSize === dataMatchedSize) {
      variant.click();
      element.classList.add("size-selected");
    }
  });
};

const addCart = () => {
  addButton.click();
  variantModalClose.click();
};

document.addEventListener("DOMContentLoaded", (event) => {
  const sizeChartImage = document.querySelector(".size-chart-image");
  const sizeChartTable = document.querySelector(".size-guide-table-content");
  const prdImage = sizeChartTable?.getAttribute("data-sizeImage");
  const textIn = document.querySelector(".text-in");
  const textCm = document.querySelector(".text-cm");
  const tableIn = document.querySelector(".table-in");
  const tableCm = document.querySelector(".table-cm");

  // Function to show inches table and hide centimeters table
  const showInches = () => {
    tableIn.classList.remove("tw-hidden"); // Show inches table
    tableCm.classList.add("tw-hidden"); // Hide centimeters table
    textCm.classList.remove("tw-bg-[#e5e5e5]");
    textIn.classList.add("tw-bg-[#e5e5e5]");
  };

  // Function to show centimeters table and hide inches table
  const showCm = () => {
    tableCm.classList.remove("tw-hidden"); // Show centimeters table
    tableIn.classList.add("tw-hidden"); // Hide inches table
    textCm.classList.add("tw-bg-[#e5e5e5]");
    textIn.classList.remove("tw-bg-[#e5e5e5]");
  };

  // Event listeners for the text buttons
  if (sizeChartTable) {
    textIn.addEventListener("click", showInches);
    textCm.addEventListener("click", showCm);
  }

  // Fallback product image, only when the size chart has no picture of its own. Built only then:
  // setting src starts the download even if the image is never added to the page.
  if (sizeChartImage?.innerHTML.trim() === "") {
    const img = document.createElement("img");
    if (prdImage) {
      img.setAttribute("data-sanitized-data-mce-src", prdImage);
      img.setAttribute("data-mce-src", prdImage);
      img.setAttribute("src", prdImage);
    }
    img.setAttribute("data-sanitized-data-mce-fragment", "1");
    img.setAttribute("data-mce-fragment", "1");
    img.setAttribute("alt", "Size Guide");
    sizeChartImage.appendChild(img);
  }
});
const container = document.querySelector(
  ".size-guide-table-content .metafield-rich_text_field"
);
if (container) {
  const headingText = "HOW TO MEASURE";
  const firstP = container.querySelector("p");
  const headingEl = document.createElement("p");
  headingEl.textContent = headingText;

  if (firstP?.textContent.trim() === headingText) {
    firstP.remove();
    headingEl.classList.add("replaced-heading");
  } else {
    headingEl.classList.add("new-heading");
  }

  container.prepend(headingEl);
}

/* ===============================================
 * START: PRODUCT VARIANT OPTION - LOW STOCK MESSAGE
 * =============================================== */
  window.addEventListener(PUB_SUB_EVENTS.variantChange, function(e){
    const html = e?.detail?.data?.html;
    // LOW STOCK ELEMENTS UPDATE
    const lowStockElementsListSource = html?.querySelectorAll?.('[data-variant-low-stock]') || [];
    lowStockElementsListSource.forEach(lowStockEl => {
      if (!lowStockEl) return;
      const selectorVal = lowStockEl.dataset?.variantLowStock;
      if (!selectorVal) return;
      const docLowStockEl = document?.querySelector?.(
        `[data-variant-low-stock='${selectorVal}']`
      );
      if (docLowStockEl) {
        docLowStockEl.textContent = lowStockEl.textContent ?? '';
      }
    });
    // PRODUCT SIZE POPUP
    const availableRadiosPopupSource = html?.querySelector('available-radios-unselected');
    const availableRadiosPopupDoc = document?.querySelector('available-radios-unselected');
    // Replace only if both elements exist
    if (availableRadiosPopupSource && availableRadiosPopupDoc) {
      availableRadiosPopupDoc.replaceWith(availableRadiosPopupSource);
    }
    const currentVariants = this?.document?.querySelectorAll('.size-variant') || [];
    currentVariants.forEach(label => {
      if (!label) return;

      const inputId = label.getAttribute('for');
      if (!inputId) return;

      const parent = label.parentElement;
      if (!parent) return;

      const input = parent.querySelector(`#${inputId}`);
      if (!input) return;

      const popupContainer = document.querySelector('available-radios-unselected');
      if (!popupContainer) return;

      const popSize = label.dataset?.popSize;
      if (!popSize) return;

      const popupLabel = popupContainer.querySelector(`[data-pop-size='${popSize}']`);
      if (!popupLabel) return;

      if (input.classList.contains("disabled")) {
        popupLabel.classList.add("size-pop-variant__disabled");
      } else if (input.checked) {
        popupLabel.classList.add("size-selected");
      }
    });
  })
/* ===============================================
 * END: PRODUCT VARIANT OPTION - LOW STOCK MESSAGE
 * =============================================== */
